module.exports = __webpack_public_path__ + "gif.2a3448ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/feeds/gif.png
// module id = 1518
// module chunks = 0